import { render, staticRenderFns } from "./workshopGroupModal.vue?vue&type=template&id=da754498&scoped=true&"
import script from "./workshopGroupModal.vue?vue&type=script&lang=js&"
export * from "./workshopGroupModal.vue?vue&type=script&lang=js&"
import style0 from "./workshopGroupModal.vue?vue&type=style&index=0&id=da754498&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da754498",
  null
  
)

export default component.exports